import { createAxiosInstance } from "./index";
import hostConfig from "@/config/hostResolver";

const baseUrl = process.env.VUE_APP_BUDGET_URL ?? `${hostConfig.apiBaseUrl}/budget-service`;

class BudgetService {
  constructor() {
    this.apiClient = createAxiosInstance(baseUrl);
  }
  getBudgets(params = {}, version = 1) {
    return this.apiClient
      ?.get("/budgets", { params, errorContext: "Failed to get budgets" })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.log("Error!", error.response);
        if (version == 2) throw error;
        return error;
      });
  }
  getBudgetsAdminView(params = {}) {
    return this.apiClient
      ?.get(`/budgets/admin`, { params, errorContext: "Failed to get budgets" })
      .then((response) => {
        return response?.data || response;
      });
  }
  getParentBudgets(params = {}) {
    console.log({ params });
    return this.apiClient
      ?.get("/budgets/parents", {
        params,
        errorContext: "Failed to get budgets",
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.log("Error!", error.response);
        return error;
      });
  }
  getBudgetFundingStatuses() {
    return this.apiClient
      ?.get("/budgets/funding", {
        errorContext: "Failed to get budget funding statuses",
      })
      .then((response) => {
        return response.data.funding;
      })
      .catch((error) => {
        console.log("Error getting budget funding status", error.response);
        throw error;
      });
  }
  createBudget(budget) {
    return this.apiClient
      ?.post("/budgets", budget, { errorContext: "Failed to create budgets" })
      .then((response) => {
        console.log(response.data.budget);
        return response.data.budget;
      })
      .catch((error) => {
        console.log("Error!", error);
        return error;
      });
  }
  getBudget(budgetId) {
    return this.apiClient
      ?.get("/budgets/" + budgetId, { errorContext: "Failed to get budget" })
      .then((response) => {
        console.log(response.data);
        return response.data;
      })
      .catch((error) => {
        console.log("Error!", error.response);
        throw error;
      });
  }
  updateBudget(budgetId, budget) {
    return this.apiClient
      ?.patch("/budgets/" + budgetId, budget, {
        errorContext: "Failed to update budget",
      })
      .then((response) => {
        console.log(response);
        return response.data;
      })
      .catch((error) => {
        console.log("Error!", error);
        return error;
      });
  }
  deleteBudget(budgetId) {
    return this.apiClient
      ?.delete("/budgets/" + budgetId, {
        errorContext: "Failed to delete budget",
      })
      .then((response) => {
        console.log(response);
        return response.data;
      })
      .catch((error) => {
        console.log("Error deleting budget!", error);
        throw error?.response?.data || error;
      });
  }

  getAwards() {
    return this.apiClient
      ?.get("/awards", { errorContext: "Failed to get awards" })
      .then((response) => {
        console.log(response.data);
        return response.data;
      })
      .catch((error) => {
        console.log("Error!", error.response);
        return error;
      });
  }
  createAward(award) {
    return this.apiClient
      ?.post("/awards", award, { errorContext: "Failed to create award" })
      .then((response) => {
        console.log(response);
        return response.data;
      })
      .catch((error) => {
        console.log("Error!", error);
        return error;
      });
  }
  getAward(awardId) {
    return this.apiClient
      ?.get("/awards/" + awardId, { errorContext: "Failed to get award" })
      .then((response) => {
        console.log(response.data);
        return response.data;
      })
      .catch((error) => {
        console.log("Error!", error.response);
        return error;
      });
  }
  updateAward(awardId, award) {
    return this.apiClient
      ?.patch("/awards/" + awardId, award, {
        errorContext: "Failed to update award",
      })
      .then((response) => {
        console.log(response);
        return response.data;
      })
      .catch((error) => {
        console.log("Error!", error);
        return error;
      });
  }

  deleteAward(awardId) {
    return this.apiClient
      ?.delete("/awards/" + awardId, { errorContext: "Failed to delete award" })
      .then((response) => {
        console.log(response);
        return response.data;
      })
      .catch((error) => {
        console.log("Error!", error);
        return error;
      });
  }

  // V2 API Calls
  getBudgetUsersV2(params) {
    return this.apiClient
      ?.get("/v2/budget-user", {
        params,
        errorContext: "Failed to get budget managers",
      })
      .then((response) => {
        return response?.data || response;
      })
      .catch((error) => {
        console.log("Error getting budget users!", error.response || error);
        throw error;
      });
  }
  createManagerBudgets(body) {
    return this.apiClient
      ?.post("/v2/budget/wizard", body, {
        errorContext: "Failed to create budget managers",
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.log("Error creating manager budgets", error.response || error);
        throw error && error.response ? error.response.data || error.response : error;
      });
  }
  getBudgetActivityRequestsV2(params, index = false) {
    return this.apiClient
      ?.get(`/v2/budget-activity/requests${index ? `/index` : ""}`, {
        params,
        errorContext: "Failed to get funding requests",
      })
      .then((response) => {
        return response?.data || response;
      });
  } //getBudgetActivityRequestsV2

  async getBudgetsV2(params, budgetId = null) {
    return await this.apiClient?.get(`/v2/budget${budgetId ? `/${budgetId}` : ``}`, {
      params,
      errorContext: "Failed to get budgets",
    });
  } //getBudgetsV2

  async createBudgetPSPSNumbers(body) {
    return await this.apiClient?.post(`/v3/budget-psps-number`, body, {
      errorContext: "Failed to create budget psps numbers",
    });
  } //createBudgetPSPSNumbers
}

export default BudgetService;
